interface String {
  extractNumber(): number;
}
String.prototype.extractNumber = function (): number {
  return Number(this.match(/\d+/)[0]);
};
